import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M600-141.54l-240-84-172.15 66.61q-17.69 6.85-32.77-3.92Q140-173.62 140-192.31v-524.61q0-11.85 6.35-21.27 6.34-9.42 17.81-13.65L360-818.46l240 84 172.15-66.61q17.69-6.85 32.77 3.34Q820-787.54 820-769.23v527.69q0 12.23-6.92 21.46-6.93 9.23-18.77 13.46L600-141.54zm-30-73.38v-468l-180-62.93v468l180 62.93zm60 0L760-258v-474l-130 49.08v468zM200-228l130-49.85v-468L200-702v474zm430-454.92v468-468zm-300-62.93v468-468z"
      ></path>
    </svg>
  );
}

export default Icon;
